import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const Search = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      fill="currentColor"
      d="M18.25 10.13a8.1 8.1 0 0 1-1.56 4.79l4.94 4.95a1.25 1.25 0 1 1-1.77 1.77l-4.94-4.95a8.08 8.08 0 0 1-4.8 1.56 8.12 8.12 0 1 1 8.13-8.13zm-8.12 5.62a5.63 5.63 0 0 0 5.62-5.63 5.63 5.63 0 0 0-5.63-5.62 5.63 5.63 0 0 0-5.62 5.63 5.63 5.63 0 0 0 5.63 5.62z"
    />
  </svg>
));
